module.exports = __webpack_public_path__ + "fonts/Lexend-ExtraBold.93a6cda.woff2";